import { ComponentInterface, Entity } from '@goodboydigital/odie';
import { Container } from 'pixi.js';

import { Entity25D } from './Entity25D';

export interface View25DComponentOptions
{
    layer?: string;
    view?: Container;
}

export class View25DComponent implements ComponentInterface<View25DComponentOptions>
{
    public static DEFAULT_NAME = 'view25d';

    public data: View25DComponentOptions;
    public view: Container;
    public entity?: Entity25D;

    constructor(_entity: Entity, data: View25DComponentOptions = {})
    {
        this.data = data;
        this.view = data.view || new Container();
    }

    public addedToEntity(en: Entity): void
    {
        this.entity = en as Entity25D;
    }

    public render(): void
    {
        if (!this.entity) return;
        const system = this.entity.scene.view25d;
        const m = ((this.entity.z * system.camera.zoom * system.perspective) + 1);

        this.view.position.x = (this.entity.x - system.camera.x) * m;
        this.view.position.y = (this.entity.y - system.camera.y) * m;
        this.view.zIndex = this.entity.z;
    }
}
